<template id="bannerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>

    <!-- Snackbar -->
    <div id="snackbar" class="snackbar alert">{{serverMessage}}</div>

    <!-- Sticky Toolbar with Action Button -->
    <section class="toolbar">
      <h1>Design Thoob Steps</h1>
      <button
        type="button"
        class="btn btn-info"
        v-on:click="update()"
      >Save Changes</button>
    </section>

    <div class="main-div" :class="formState.invalidShake ? 'invalid' : ''">
      <!-- Loading -->
      <div class="spinner-wrapper" v-bind:class="formState.loading ? 'show' : 'hide'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <p class="alert alert-danger text-left" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </p>

      <form class="col-12" :disabled="formState.loading" v-if="this.data.section">
        <div class="row  text-left">
            <!-- Title -->
            <div class="form-group col-sm-6">
                <label for="title">Title</label>
                <input
                class="form-control"
                type="text"
                v-model="data.section.title"
                id="title"
                />
            </div>
            <div class="form-group col-sm-6">
                <label for="title_en">Title (EN)</label>
                <input
                class="form-control"
                type="text"
                v-model="data.section.title_en"
                id="title_en"
                />
            </div>

            <!-- Content/Description -->
            <div class="form-group col-sm-6">
                <label for="content">Description</label>
                <textarea
                class="form-control"
                id="content"
                cols="30"
                rows="3"
                v-model="data.section.content"
                >
                </textarea>
            </div>
            <div class="form-group col-sm-6">
                <label for="content_en">Description (EN)</label>
                <textarea
                class="form-control"
                id="content_en" 
                cols="30"
                rows="3"
                v-model="data.section.content_en"
                >
                </textarea>
            </div>

            <!-- Button Text -->
            <div class="form-group col-sm-6">
                <label for="btn_text">Button Text</label>
                <input
                class="form-control"
                type="text"
                v-model="data.section.btn_text"
                id="btn_text"
                
                />
            </div>
            <div class="form-group col-sm-6">
                <label for="btn_text_en">Button Text (EN)</label>
                <input
                class="form-control"
                type="text"
                v-model="data.section.btn_text_en"
                id="btn_text_en"
                
                />
            </div>

            <!-- URL -->
            <div class="form-group col-sm-6">
              <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
              <div class="form-inline">
                <!--
                -- TODO: Website URL must be changed in case we need a new instance on a different domain
                -->
                <span class="mr-1">ithoob.com/</span>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.section.btn_url"
                  id="btn_url"
                />
              </div>
            </div>

            <!-- Upload Image -->
            <div class="form-group col-sm-6">
                <label for="section_image">Upload Image <br><small class="text-muted">*1 : 1.25 (W : H) for section image - Example: 800x900</small></label>
                <input
                class="form-control"
                type="file"
                id="section_image"
                @change="uploadFile('section_image')"
                />
            </div>


            <!-- Image Preview -->
            <div class="img-preview col-12">
                <img :src="data.section.image">
            </div>
        </div>

        <div role="tablist" class="mt-3">
          <h2 class="text-left">Steps:</h2>
          <b-card no-body class="col-12 mb-1 p-0" v-for="(step, index) in this.data.section.steps" :key="index+1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + (index+1)" variant="info">Step #{{index+1}}</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + (index+1)" accordion="my-accordion" role="tabpanel">
              <b-card-body class="row text-left">
                
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="step.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="step.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="step.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="step.content_en"
                    >
                  </textarea>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

.toolbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  right: 0;
  padding: 10px 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99;
}

h1 {
  margin-bottom: 0;
}

.card {
  transition: all 150ms ease-in-out;

  &:hover {
    background: #fafafa;
  }
}

.img-preview {
  max-height: 500px;
  text-align: center;

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
}

.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}

.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  margin-top: 50px;
  padding: 50px;
  width: 80%;
}

.spinner-wrapper {
  display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(230, 230, 230, 0.61);
  z-index: 99;
}
.spinner-wrapper.show {
  display: flex;
}
.spinner-wrapper.hide {
  display: none;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
}

.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}


/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar {
  position: fixed;
  bottom: -100px;
  left: 40%;
  z-index: 1;
  transition: all 300ms ease-in-out;
}

.snackbar.show {
  bottom: 30px;
  opacity: 1;
}


</style>

<script>
import axios from "axios";
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "three_steps_section",
    data() {
    return {
      data: '',
      errors: [], // Form's errors
      serverMessage: '',
      formState: {
        loading: false,
        invalidShake: false
      },
      image: {
        uploaded: null,
        newFileUpload: null,
        value: null
      }
    };
  },
  watch: {
		
	},
  mounted() {
    this.getFirstHomeSection();
  },
  methods: {
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        1000
      );
    },
    checkForm() {
      // Reset errors
      this.errors = [];

      // Validate form inputs
      let { section } = this.data;

      // Limits
      let titleMax = 40;
      let descMax = 120;
      let btnTextMax = 30;
      let stepTitleMax = 20;
      let stepDescMax = 130;
      
      if (section.title) {
          if (section.title.length > titleMax) {
            this.errors.push(`Section Title must be ${titleMax} characters maximum`);
          }
        } else {
          this.errors.push(`Section Title is required`);
        }
        if (section.title_en) {
          if (section.title_en.length > titleMax) {
            this.errors.push(`Section Title (EN) must be ${titleMax} characters maximum`);
          }
        } else {
          this.errors.push(`Section Title (EN) is required`);
        }

        // Content
        if (section.content) {
          if (section.content.length > descMax) {
            this.errors.push(`Section Description must be ${descMax} characters maximum`)
          }
        } else {
          this.errors.push(`Section Description is required`);
        }
        if (section.content_en) {
          if (section.content_en.length > descMax) {
            this.errors.push(`Section Description (EN) must be ${descMax} characters maximum`)
          }
        } else {
          this.errors.push(`Section Description (EN) is required`);
        }

        // Button
        if (section.btn_text) {
          if (section.btn_text.length > btnTextMax) {
            this.errors.push(`Section Button Text must be ${btnTextMax} characters maximum`)
          }
        } else {
          this.errors.push(`Section Button Text is required`);
        }
        if (section.btn_text_en) {
          if (section.btn_text_en.length > btnTextMax) {
            this.errors.push(`Section Button Text (EN) must be ${btnTextMax} characters maximum`)
          }
        } else {
          this.errors.push(`Section Button Text (EN) is required`);
        }

        // URL
        if (!section.btn_url) {
          this.errors.push(`Section Button URL is required`);
        }

        // Image
        if (!section.image) {
          this.errors.push(`Section Image is required`);
        }

        // 3 Steps Validation
        section.steps.map((step, index) => {
          if (step.title) {
            if (step.title.length > stepTitleMax) {
              this.errors.push(`Step #${index+1} Title must be ${stepTitleMax} characters maximum`);
            }
          } else {
            this.errors.push(`Step #${index+1} Title is required`);
          }
          if (step.title_en) {
            if (step.title_en.length > stepTitleMax) {
              this.errors.push(`Step #${index+1} Title (EN) must be ${stepTitleMax} characters maximum`);
            }
          } else {
            this.errors.push(`Step #${index+1} Title (EN) is required`);
          }

          // Content
          if (step.content) {
            if (step.content.length > stepDescMax) {
              this.errors.push(`Step #${index+1} Description must be ${stepDescMax} characters maximum`)
            }
          } else {
            this.errors.push(`Step #${index+1} Description is required`);
          }
          if (step.content_en) {
            if (step.content_en.length > stepDescMax) {
              this.errors.push(`Step #${index+1} Description (EN) must be ${stepDescMax} characters maximum`)
            }
          } else {
            this.errors.push(`Step #${index+1} Description (EN) is required`);
          }
        })

    },
    getFirstHomeSection() {
      // Show Loader
      this.formState.loading = true;

      // Get statics Data
      return axios
        .get(`${herokuUrl}/dashboard/first-home-section`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.data = res.data;

          // Stop the loader
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Section fetching failed, " + err.response.data.message);
          }
        });
    },
    compress(elem, sizeW, sizeH, compressedFileObj) {
        const width = sizeW;
        const height = sizeH;
        const fileName = elem.files[0].name;
        const reader = new FileReader();
        // console.log(elem.files[0]);
        reader.readAsDataURL(elem.files[0]);
        return (reader.onload = event => {
            const img = new Image();
            img.src = event.target.result;
            (img.onload = () => {
                const elem = document.createElement("canvas");
                elem.width = width;
                elem.height = height;
                const ctx = elem.getContext("2d");
                // img.width and img.height will contain the original dimensions
                ctx.drawImage(img, 0, 0, width, height);
                ctx.canvas.toBlob(
                    blob => {
                        const file = new File([blob], fileName, {
                            type: "image/jpeg",
                            lastModified: Date.now()
                        });
                        compressedFileObj.flag = true;
                        compressedFileObj.file = file;
                    },
                    "image/jpeg",
                    1
                );
            }),
            (reader.onerror = error => {compressedFileObj.flag = "error"; console.log(error)});
        });
    },
    /**
     * TODO: This function uploads the file directly to the server. Without confirming first.
     * It must upload the image after submitting the form.
     * 
     * [WHY] User might try to upload multiple images for testing purposes, without submitting. 
     * This will pump the server with too many unused images.
     */
    uploadFile(imgName) {
      if(!(document.getElementById(imgName).files[0] && document.getElementById(imgName).files[0].name))
      return;
      this.formState.loading = true;
      this.image.uploaded = false;
      let checkObj = {file: null, flag: false};
      this.compress(document.getElementById(imgName), 800, 900, checkObj);
      // let file = document.getElementById("image").files[0];
      let fn = () => {
        if (checkObj.flag && checkObj.flag != "error") {
          this.image.newFileUpload = new FormData();
          this.image.newFileUpload.set("images", checkObj.file);
          axios
            .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user")
              }
            })
            .then(res => {  
              if (res.data.status) {
                this.image.uploaded = true;
                this.image.value = res.data.sources[0];
                this.formState.loading = false;
                // console.log(res)
                // Add the uploaded image path to its static object
                this.data.section.image = res.data.sources[0];
                
              } else {
                alert("Couldn't Upload file, File too large or    " + res.message);
                this.formState.loading = false;
              }
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                  err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        }
        else if (checkObj.flag == "error") {
          alert("Compression Error")
          this.formState.loading = false;
        }
        else {
          setTimeout(fn, 200);
        }
      }
      fn();
    },
    update() {
      // Check if form is validated
      this.checkForm();

      // If there's any error, shake the form. If not, start the update process
      if (!this.errors.length) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;
        return axios.post(`${herokuUrl}/dashboard/update-three-steps-section`, this.data.section, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(() => {
          this.formState.loading = false;
          this.serverMessage = "This section has been updated successfully";
          snackbar.className = "snackbar show alert alert-success";
          snackbar.classList.remove('alert-danger'); // If exist, it will be deleted
          snackbar.classList.add('show', 'alert-success');
          setTimeout(function() { 
            snackbar.className = snackbar.className.replace("show", ""); 
          }, 3000);
        })
        .catch(err => {
          // console.log(err)
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            this.serverMessage = "There was a problem, and we couldn't update your banner";
            snackbar.classList.remove('alert-success'); // If exist, it will be deleted
            snackbar.classList.add('show', 'alert-danger');
            setTimeout(function() { 
              snackbar.className = snackbar.className.replace("show", ""); 
            }, 3000);
          }
        });
      } else {
        this.shakeForm();
      }
      
    },
    
	},
  components: {
    appNavigation: Navigation
  }
};
</script>
